<template>
  <div class="custom-container" v-loading.fullscreen.lock="category.isLoading">
    <el-row type="flex" align="center" class="my-4" justify="space-between">
      <el-col :span="5">
        <div class="category-title">Edit Category</div>
      </el-col>
      <el-col :span="4">
        <el-row type="flex" justify="end">
          <el-button size="small" @click="$router.go(-1)">Kembali</el-button>
          <el-button size="small" type="primary" @click="save">Simpan</el-button>
        </el-row>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="12">
        <el-form label-position="left" ref="category" label-width="120px" :model="category.data">
          <Form :Category="category.data"></Form>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Form from "./Form";
import { mapActions, mapState } from "vuex";
export default {
  props: ["id"],
  components: {
    Form
  },
  data: () => ({
    valid: true
  }),
  computed: {
    ...mapState({
      category: state => state.category.category
    })
  },
  methods: {
    ...mapActions({
      getCategory: "category/GetCategory",
      updateCategory: "category/UpdateCategory"
    }),
    save() {
      this.$refs.category.validate(valid => {
        if (valid) {
          this.updateCategory(this.category.data);
          this.snackbar = true;
        } else {
          return false;
        }
      });
    },
    reset() {
      this.$refs.form.reset();
    }
  },
  created() {
    this.getCategory(this.id);
  }
};
</script>

<style>
</style>
